import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { SystemService } from "common/services/core-services/system.service";
import { BranchesModel } from "common/models/page-models/Branches/branches-data-model";
import { BranchesMetaModel } from "common/models/page-models/Branches/branches-form-meta-model";
import { BranchesFormDataService } from "common/services/data-services/admin/branches/branches-form-data.service";
import { branchCategoryListDataService } from "common/services/data-services/custom-service/branchCategoryList.service";


@Injectable({
    providedIn: 'root'
})
export class BranchesFormWidgetService extends FormWidgetService<BranchesModel> {
    constructor(protected ds: BranchesFormDataService, private ss: SystemService, private brancCat:branchCategoryListDataService ) {
        super(ds);

    }

    override prepareMetaModel(dataModel: DataModel, metaModel: BranchesMetaModel, routeData: WidgetModel): Promise<BranchesMetaModel> {
        return new Promise<BranchesMetaModel>((resolve, reject) => {
            metaModel.pageTitle = dataModel.id !== 0 ?  'Update Branch' : 'Add Branch';
            // metaModel.properties['branchCategoryId'].options = this.ss.dataStorage.branchCategory;
            this.brancCat.postData({}).then((data) => {
                metaModel.properties['branchCategoryId'].options = data.details;
              });
            resolve(metaModel);
        });
    }



    getMetaModel(): MetaModel {
        const meta = new BranchesMetaModel();
        return meta.getMetaModel();
    }
}
